import React from "react";

type SectionHeaderProps = {
  title: string;
  showDivider?: boolean;
};

export const SectionHeader = ({
  title,
  showDivider = true
}: SectionHeaderProps) => {
  return (
    <>
      {showDivider && (
        <div className="PreviewBookingModalBeta__divider w-full h-px bg-[var(--borderColor)] my-6" />
      )}
      <h3 className="mb-6 font-semibold text-[1.1rem] text-[var(--primaryColor)]">
        {title}
      </h3>
    </>
  );
};
